import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/esnext.string.at.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { buildReportingRequestPeriodItems } from '~/functions/reporting';
import { sortReferencePeriods } from '~/functions/referencePeriods';
import IxFormInputDatePicker from '~/components/ix/form-input/DatePicker.vue';
import { MetricReportingPeriodType, ReportingRequestType, useGetAccountQuery, useGetFundIsInSyncQuery, useListFundsQuery, useReportingRequestKpiOptionsQuery, useReportingVenturesMissingEsgModuleQuery, useReportingVenturesMissingImpactCarryQuery, useUpsertReportingRequestMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'RequestDialog',
  props: {
    portfolioId: null
  },
  emits: ['success'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _ref2 = getCurrentInstance(),
      proxy = _ref2.proxy;
    var dialogOpen = ref(false);
    var requestType = ref(ReportingRequestType.Kpi);
    var selectedFundId = ref(null);
    var referencePeriod = ref('');
    var dueDate = ref(null);
    var requestTitle = ref('');
    var description = ref('');
    var titleError = ref(false);
    var submitting = ref(false);
    var kpiScope = ref('ALL');
    var selectedMetricIds = ref([]);
    var kpiSelectionError = ref(false);
    var requestTypeItems = computed(function () {
      return [{
        value: ReportingRequestType.Kpi,
        text: proxy.$t('dialog.dataTypeKpi')
      }, {
        value: ReportingRequestType.ImpactCarry,
        text: proxy.$t('dialog.dataTypeImpactCarry')
      }, {
        value: ReportingRequestType.Esg,
        text: proxy.$t('dialog.dataTypeEsg')
      }];
    });
    var _useUpsertReportingRe = useUpsertReportingRequestMutation({}),
      upsertReportingRequest = _useUpsertReportingRe.mutate;
    var listDataEnabled = computed(function () {
      return dialogOpen.value && !!props.portfolioId;
    });
    var _useListFundsQuery = useListFundsQuery(function () {
        return {};
      }, computed(function () {
        return {
          enabled: listDataEnabled.value
        };
      })),
      fundsResult = _useListFundsQuery.result,
      fundsLoading = _useListFundsQuery.loading;
    var fundOptions = computed(function () {
      var _fundsResult$value$li, _fundsResult$value;
      return ((_fundsResult$value$li = (_fundsResult$value = fundsResult.value) === null || _fundsResult$value === void 0 ? void 0 : _fundsResult$value.listFunds) !== null && _fundsResult$value$li !== void 0 ? _fundsResult$value$li : []).filter(function (fund) {
        var _fund$ventureIds$leng, _fund$ventureIds;
        return ((_fund$ventureIds$leng = (_fund$ventureIds = fund.ventureIds) === null || _fund$ventureIds === void 0 ? void 0 : _fund$ventureIds.length) !== null && _fund$ventureIds$leng !== void 0 ? _fund$ventureIds$leng : 0) > 0;
      }).map(function (fund) {
        var _fund$ventureIds2;
        return {
          id: fund.id,
          name: fund.name || String(fund.id),
          ventureIds: ((_fund$ventureIds2 = fund.ventureIds) !== null && _fund$ventureIds2 !== void 0 ? _fund$ventureIds2 : []).map(String)
        };
      }).sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    });
    var selectedFund = computed(function () {
      var _fundOptions$value$fi;
      return (_fundOptions$value$fi = fundOptions.value.find(function (fund) {
        return fund.id === selectedFundId.value;
      })) !== null && _fundOptions$value$fi !== void 0 ? _fundOptions$value$fi : null;
    });
    var selectedVentureIds = computed(function () {
      var _selectedFund$value$v, _selectedFund$value;
      return (_selectedFund$value$v = (_selectedFund$value = selectedFund.value) === null || _selectedFund$value === void 0 ? void 0 : _selectedFund$value.ventureIds) !== null && _selectedFund$value$v !== void 0 ? _selectedFund$value$v : [];
    });
    var ventureNameById = computed(function () {
      var _fundsResult$value$li2, _fundsResult$value2;
      var map = new Map();
      var _iterator = _createForOfIteratorHelper((_fundsResult$value$li2 = (_fundsResult$value2 = fundsResult.value) === null || _fundsResult$value2 === void 0 ? void 0 : _fundsResult$value2.listFunds) !== null && _fundsResult$value$li2 !== void 0 ? _fundsResult$value$li2 : []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _fund$ventures;
          var fund = _step.value;
          var _iterator2 = _createForOfIteratorHelper((_fund$ventures = fund.ventures) !== null && _fund$ventures !== void 0 ? _fund$ventures : []),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var venture = _step2.value;
              if (venture !== null && venture !== void 0 && venture.id) {
                map.set(String(venture.id), venture.name || String(venture.id));
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return map;
    });
    var _useGetAccountQuery = useGetAccountQuery(),
      accountResult = _useGetAccountQuery.result;
    var account = computed(function () {
      var _accountResult$value;
      return (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount;
    });
    var periodItems = computed(function () {
      var _account$value, _account$value2;
      var isEsg = requestType.value === ReportingRequestType.Esg;
      var isQuarterly = !isEsg && ((_account$value = account.value) === null || _account$value === void 0 ? void 0 : _account$value.reportingPeriodType) === MetricReportingPeriodType.Quarterly;
      return buildReportingRequestPeriodItems({
        annualOnly: isEsg,
        quarterly: isQuarterly,
        portfolioPeriods: ((_account$value2 = account.value) === null || _account$value2 === void 0 ? void 0 : _account$value2.defaultReferencePeriods) || []
      });
    });
    var fundSyncEnabled = computed(function () {
      return dialogOpen.value && selectedFundId.value != null;
    });
    var _useGetFundIsInSyncQu = useGetFundIsInSyncQuery(computed(function () {
        return {
          id: selectedFundId.value
        };
      }), computed(function () {
        return {
          enabled: fundSyncEnabled.value
        };
      })),
      fundSyncResult = _useGetFundIsInSyncQu.result,
      fundSyncLoading = _useGetFundIsInSyncQu.loading;
    var isFundInSync = computed(function () {
      var _fundSyncResult$value, _fundSyncResult$value2, _fundSyncResult$value3;
      return (_fundSyncResult$value = (_fundSyncResult$value2 = fundSyncResult.value) === null || _fundSyncResult$value2 === void 0 ? void 0 : (_fundSyncResult$value3 = _fundSyncResult$value2.getFund) === null || _fundSyncResult$value3 === void 0 ? void 0 : _fundSyncResult$value3.isInSync) !== null && _fundSyncResult$value !== void 0 ? _fundSyncResult$value : true;
    });
    var missingCarryEnabled = computed(function () {
      return dialogOpen.value && requestType.value === ReportingRequestType.ImpactCarry && selectedVentureIds.value.length > 0;
    });
    var _useReportingVentures = useReportingVenturesMissingImpactCarryQuery(computed(function () {
        return {
          ventureIds: selectedVentureIds.value
        };
      }), computed(function () {
        return {
          enabled: missingCarryEnabled.value
        };
      })),
      missingCarryResult = _useReportingVentures.result;
    var missingImpactCarryVentureIds = computed(function () {
      var _missingCarryResult$v, _missingCarryResult$v2;
      return (_missingCarryResult$v = (_missingCarryResult$v2 = missingCarryResult.value) === null || _missingCarryResult$v2 === void 0 ? void 0 : _missingCarryResult$v2.reportingVenturesMissingImpactCarry) !== null && _missingCarryResult$v !== void 0 ? _missingCarryResult$v : [];
    });
    var missingEsgModuleEnabled = computed(function () {
      return dialogOpen.value && requestType.value === ReportingRequestType.Esg && selectedVentureIds.value.length > 0;
    });
    var _useReportingVentures2 = useReportingVenturesMissingEsgModuleQuery(computed(function () {
        return {
          ventureIds: selectedVentureIds.value
        };
      }), computed(function () {
        return {
          enabled: missingEsgModuleEnabled.value
        };
      })),
      missingEsgModuleResult = _useReportingVentures2.result;
    var missingEsgModuleVentureIds = computed(function () {
      var _missingEsgModuleResu, _missingEsgModuleResu2;
      return (_missingEsgModuleResu = (_missingEsgModuleResu2 = missingEsgModuleResult.value) === null || _missingEsgModuleResu2 === void 0 ? void 0 : _missingEsgModuleResu2.reportingVenturesMissingEsgModule) !== null && _missingEsgModuleResu !== void 0 ? _missingEsgModuleResu : [];
    });
    var kpiOptionsEnabled = computed(function () {
      return dialogOpen.value && requestType.value === ReportingRequestType.Kpi && kpiScope.value === 'SPECIFIC' && selectedVentureIds.value.length > 0;
    });
    var _useReportingRequestK = useReportingRequestKpiOptionsQuery(computed(function () {
        return {
          ventureIds: selectedVentureIds.value
        };
      }), computed(function () {
        return {
          enabled: kpiOptionsEnabled.value
        };
      })),
      kpiOptionsResult = _useReportingRequestK.result,
      kpiOptionsLoading = _useReportingRequestK.loading;
    var kpiOptions = computed(function () {
      var _kpiOptionsResult$val, _kpiOptionsResult$val2;
      return (_kpiOptionsResult$val = (_kpiOptionsResult$val2 = kpiOptionsResult.value) === null || _kpiOptionsResult$val2 === void 0 ? void 0 : _kpiOptionsResult$val2.reportingRequestKpiOptions) !== null && _kpiOptionsResult$val !== void 0 ? _kpiOptionsResult$val : [];
    });
    var selectedKpiOptions = computed(function () {
      return kpiOptions.value.filter(function (option) {
        return selectedMetricIds.value.includes(option.metricId);
      });
    });
    var matchedKpiCountByVenture = computed(function () {
      var map = new Map();
      var _iterator3 = _createForOfIteratorHelper(selectedKpiOptions.value),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var option = _step3.value;
          var _iterator4 = _createForOfIteratorHelper(option.ventureIds),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var ventureId = _step4.value;
              var key = String(ventureId);
              map.set(key, (map.get(key) || 0) + 1);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return map;
    });
    var matchedVentureIds = computed(function () {
      return Array.from(matchedKpiCountByVenture.value.keys()).sort(function (a, b) {
        return (ventureNameById.value.get(a) || a).localeCompare(ventureNameById.value.get(b) || b);
      });
    });
    var defaultReferencePeriod = function defaultReferencePeriod() {
      var _account$value3;
      var portfolioDefaults = ((_account$value3 = account.value) === null || _account$value3 === void 0 ? void 0 : _account$value3.defaultReferencePeriods) || [];
      if (portfolioDefaults.length > 0) {
        return sortReferencePeriods(portfolioDefaults).at(-1) || String(new Date().getFullYear() - 1);
      }
      return periodItems.value.at(-2) || String(new Date().getFullYear() - 1);
    };
    var resetForm = function resetForm() {
      var _fundOptions$value$0$, _fundOptions$value$;
      selectedFundId.value = (_fundOptions$value$0$ = (_fundOptions$value$ = fundOptions.value[0]) === null || _fundOptions$value$ === void 0 ? void 0 : _fundOptions$value$.id) !== null && _fundOptions$value$0$ !== void 0 ? _fundOptions$value$0$ : null;
      requestType.value = ReportingRequestType.Kpi;
      requestTitle.value = '';
      description.value = '';
      dueDate.value = null;
      referencePeriod.value = defaultReferencePeriod();
      titleError.value = false;
      kpiScope.value = 'ALL';
      selectedMetricIds.value = [];
      kpiSelectionError.value = false;
    };
    watch(dialogOpen, function (isOpen) {
      if (isOpen) {
        resetForm();
      }
    });
    watch(requestType, function (type) {
      if (type === ReportingRequestType.Esg && referencePeriod.value.includes(' ')) {
        var annualPeriods = periodItems.value.filter(function (period) {
          return !period.includes(' ');
        });
        referencePeriod.value = annualPeriods.at(-1) || String(new Date().getFullYear() - 1);
      }
      if (type !== ReportingRequestType.Kpi) {
        kpiScope.value = 'ALL';
        selectedMetricIds.value = [];
      }
    });
    watch(fundOptions, function (options) {
      if (dialogOpen.value && !selectedFundId.value && options.length) {
        selectedFundId.value = options[0].id;
      }
    });
    watch(selectedFundId, function () {
      selectedMetricIds.value = [];
    });
    var close = function close() {
      dialogOpen.value = false;
    };
    var clearDescription = function clearDescription() {
      description.value = '';
    };
    var copyDescription = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (description.value) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return navigator.clipboard.writeText(description.value);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function copyDescription() {
        return _ref3.apply(this, arguments);
      };
    }();
    var submit = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var useSpecificKpis;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (requestTitle.value.trim()) {
                _context2.next = 3;
                break;
              }
              titleError.value = true;
              return _context2.abrupt("return");
            case 3:
              if (selectedFundId.value) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              if (referencePeriod.value) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return");
            case 7:
              useSpecificKpis = requestType.value === ReportingRequestType.Kpi && kpiScope.value === 'SPECIFIC';
              if (!(useSpecificKpis && !selectedMetricIds.value.length)) {
                _context2.next = 11;
                break;
              }
              kpiSelectionError.value = true;
              return _context2.abrupt("return");
            case 11:
              submitting.value = true;
              _context2.prev = 12;
              _context2.next = 15;
              return upsertReportingRequest({
                input: {
                  fundId: selectedFundId.value,
                  requestType: requestType.value,
                  title: requestTitle.value.trim(),
                  referencePeriod: referencePeriod.value,
                  description: description.value,
                  dueDate: dueDate.value || undefined,
                  metricIds: useSpecificKpis ? selectedMetricIds.value : undefined
                }
              });
            case 15:
              window.$nuxt.$emit('userMsg', {
                color: 'green',
                message: proxy.$t('dialog.successCreate')
              });
              emit('success');
              close();
              _context2.next = 23;
              break;
            case 20:
              _context2.prev = 20;
              _context2.t0 = _context2["catch"](12);
              window.$nuxt.$emit('userError', {
                message: (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message) || String(_context2.t0)
              });
            case 23:
              _context2.prev = 23;
              submitting.value = false;
              return _context2.finish(23);
            case 26:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[12, 20, 23, 26]]);
      }));
      return function submit() {
        return _ref4.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      emit: emit,
      proxy: proxy,
      dialogOpen: dialogOpen,
      requestType: requestType,
      selectedFundId: selectedFundId,
      referencePeriod: referencePeriod,
      dueDate: dueDate,
      requestTitle: requestTitle,
      description: description,
      titleError: titleError,
      submitting: submitting,
      kpiScope: kpiScope,
      selectedMetricIds: selectedMetricIds,
      kpiSelectionError: kpiSelectionError,
      requestTypeItems: requestTypeItems,
      upsertReportingRequest: upsertReportingRequest,
      listDataEnabled: listDataEnabled,
      fundsResult: fundsResult,
      fundsLoading: fundsLoading,
      fundOptions: fundOptions,
      selectedFund: selectedFund,
      selectedVentureIds: selectedVentureIds,
      ventureNameById: ventureNameById,
      accountResult: accountResult,
      account: account,
      periodItems: periodItems,
      fundSyncEnabled: fundSyncEnabled,
      fundSyncResult: fundSyncResult,
      fundSyncLoading: fundSyncLoading,
      isFundInSync: isFundInSync,
      missingCarryEnabled: missingCarryEnabled,
      missingCarryResult: missingCarryResult,
      missingImpactCarryVentureIds: missingImpactCarryVentureIds,
      missingEsgModuleEnabled: missingEsgModuleEnabled,
      missingEsgModuleResult: missingEsgModuleResult,
      missingEsgModuleVentureIds: missingEsgModuleVentureIds,
      kpiOptionsEnabled: kpiOptionsEnabled,
      kpiOptionsResult: kpiOptionsResult,
      kpiOptionsLoading: kpiOptionsLoading,
      kpiOptions: kpiOptions,
      selectedKpiOptions: selectedKpiOptions,
      matchedKpiCountByVenture: matchedKpiCountByVenture,
      matchedVentureIds: matchedVentureIds,
      defaultReferencePeriod: defaultReferencePeriod,
      resetForm: resetForm,
      close: close,
      clearDescription: clearDescription,
      copyDescription: copyDescription,
      submit: submit,
      IxFormInputDatePicker: IxFormInputDatePicker,
      ReportingRequestType: ReportingRequestType
    };
  }
});